<template>
    <x-data-table
        class="inverse no-row-hover dashed-rows"
        :headers="insuredTableHeaders"
        :items="value"
        hide-actions
    >
        <template v-slot:no-data>
            <p class="error-message text-xs-center">No data found</p>
        </template>
        <template v-slot:items="props">
            <tr>
                <td>
                    {{ props.item.insured.name }}
                </td>
                <td>
                    {{ (props.item.address) ? props.item.address.line1 : 'N/A' }}
                </td>
            </tr>
        </template>
    </x-data-table>
</template>

<script>

export default {
    name: 'SubmissionInsuredDataList',
    props: {
        value: null
    },
    computed: {
        insuredTableHeaders() {
            return [
                {
                    text: 'Insured',
                    value: 'value.insured.name'
                },
                {
                    text: 'Address',
                    value: 'value.address.line1'
                },
            ]
        }
    }
}
</script>
